import { Product } from './types';

export const watchProducts: Product[] = [
  {
    id: 'watch-1',
    numericId: 701,
    name: 'WB1 智能手表',
    description: '全套智能家居解决方案，一键控制全屋设备',
    price: '5,599₽',
    image: '/images/watch/scene/WB1/WB1主图.jpg',
    cardImage: '/images//watch/WB1.png',
    gallery: [
      {
        src: '/images/watch/scene/WB1/WB1场景图1.jpg',
      },
      {
        src: '/images/watch/scene/WB1/WB1场景图2.jpg',
      },
      {
        src: '/images/watch/scene/WB1/WB1场景图3.jpg',
      },
      {
        src: '/images/watch/scene/WB1/WB1场景图4.jpg',
      }
    ],
    features: [
        "AMOLED显示屏，支持2.5D交互式动画",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，蓝牙通话功能，AOD表盘功能，覆盖灭屏功能，手势唤醒功能，铃声自选功能，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能，天气、音乐控制、日历、计算器、小游戏等应用",
        "续航时间超过7天"
      ],
    specifications: {
        '产品尺寸': '50.2*41.4*11.5mm',
        '产品净重' : '36g',
        '中框材质': '塑料喷金属漆',
        '按钮材质': '铝合金',
        '屏幕类型': 'Amoled',
        '屏幕尺寸': '1.85"',
        '屏幕分辨率': '390*450',
        '玻璃材质': 'Panda',
        '内存': '1GB',
        '蓝牙版本': '5.3',
        '电池容量': '300mAh',
        '充电接口': '磁吸充电',
        '防水等级': 'IP68',
        '表带材质': '硅胶'
  }
  },
   {
    id: 'watch-2',
    numericId: 702,
    name: 'WM1 机械智能手表',
    description: '厨房设备智能化解决方案，提升烹饪体验',
    price: '9,999₽',
    image: '/images/watch/scene/WM1/WM1主图.jpg',
    cardImage: 'images/watch/WM1.png',
    gallery: [
      {
        src: '/images/watch/scene/WM1/WM1场景图1.jpg',
      },
      {
        src: '/images/watch/scene/WM1/WM1场景图2.jpg',
      },
      {
        src: '/images/watch/scene/WM1/WM1场景图3.jpg',
      },
      {
        src: '/images/watch/scene/WM1/WM1场景图4.jpg',
      }
    ],
    features: [
        "高清AMOLED显示屏，色彩更细腻,机械手表设计风格，更硬朗",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，蓝牙通话功能，AOD表盘功能，覆盖灭屏功能，手势唤醒功能，铃声自选功能，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能，天气、音乐控制、日历、计算器、小游戏等应用",
        "续航时间超过8天"
      ],
    specifications: {
        '产品尺寸': 'Φ44*12',
        '产品净重' : '39g',
        '中框材质': '不锈钢',
        '按钮材质': '不锈钢',
        '屏幕类型': 'Amoled',
        '屏幕尺寸': '1.43"',
        '屏幕分辨率': '466*466',
        '玻璃材质': 'Panda',
        '内存': '1GB',
        '蓝牙版本': '5.3',
        '电池容量': '350mAh',
        '充电接口': '磁吸充电',
        '防水等级': 'IP68',
        '表带材质': '不锈钢'
        }
  },
  {
    id: 'watch-3',
    numericId: 703,
    name: 'WF1 智能手表',
    description: '营造舒适睡眠环境，智能调节光线和温度',
    price: '6,699₽',
    image: '/images/watch/scene/WF1/WF1主图.jpg',
    cardImage: '/images/watch/WF1.png',
    gallery: [
      {
        src: '/images/watch/scene/WF1/WF1场景图1.jpg',
      },
      {
        src: '/images/watch/scene/WF1/WF1场景图2.jpg',
      },
      {
        src: '/images/watch/scene/WF1/WF1场景图3.jpg',
      },
      {
        src: '/images/watch/scene/WF1/WF1场景图4.jpg',
      }
    ],
    features: [
        "曲面AMOLED显示屏，交互操作更顺畅",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，蓝牙通话功能，AOD表盘功能，覆盖灭屏功能，手势唤醒功能，铃声自选功能，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能，天气、音乐控制、日历、计算器、小游戏等应用",
        "续航时间超过7天"
      ],
    specifications: {
        '产品尺寸': '46*40.2*11.3mm',
        '产品净重' : '46.3g',
        '中框材质': '铝合金',
        '按钮材质': '铝合金',
        '屏幕类型': '曲面Amoled',
        '屏幕尺寸': '1.85"',
        '屏幕分辨率': '390*450',
        '玻璃材质': 'Panda',
        '内存': '1GB',
        '蓝牙版本': '5.3',
        '电池容量': '350mAh',
        '充电接口': '磁吸充电',
        '防水等级': 'IP68',
        '表带材质': '硅胶'
        }
  },
  {
    id: 'watch-4',
    numericId: 704,
    name: 'WF2',
    description: '提升办公效率，创造舒适办公环境',
    price: '6,999₽',
    image: '/images/watch/scene/WF2/WF2主图.jpg',
    cardImage: '/images/watch/WF2.png',
    gallery: [
      {
        src: '/images/watch/scene/WF2/WF2场景图1.jpg',
      },
      {
        src: '/images/watch/scene/WF2/WF2场景图2.jpg',
      },
      {
        src: '/images/watch/scene/WF2/WF2场景图3.jpg',
      },
      {
        src: '/images/watch/scene/WF2/WF2场景图4.jpg',
      }
    ],
    features: [
        "高清AMOLED显示屏，PPI高达322，支持24bit色彩显示，屏幕滑动刷新可以达到60FPS，每一次交互操作都丝滑顺畅",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，蓝牙通话功能，AOD表盘功能，覆盖灭屏功能，手势唤醒功能，铃声自选功能，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能，天气、音乐控制、日历、计算器、小游戏等应用",
        "续航时间超过10天"
      ],
    specifications: {
        '产品尺寸': '48*41.5*10.5mm',
        '产品净重' : '43g',
        '中框材质': '铝合金',
        '按钮材质': '铝合金',
        '屏幕类型': 'Amoled',
        '屏幕尺寸': '1.99"',
        '屏幕分辨率': '410*494',
        '玻璃材质': 'Panda',
        '内存': '1GB',
        '蓝牙版本': '5.3',
        '电池容量': '350mAh',
        '充电接口': '磁吸充电',
        '防水等级': '3ATM',
        '表带材质': '液态硅胶'
        }
  },
  {
    id: 'watch-5',
    numericId: 705,
    name: 'WS1 运动智能手表',
    description: '提升办公效率，创造舒适办公环境',
    price: '6,299₽',
    image: '/images/watch/scene/WS1/WS1主图.jpg',
    cardImage: '/images/watch/WS1.png',
    gallery: [
      {
        src: '/images/watch/scene/WS1/WS1场景图1.jpg',
      },
      {
        src: '/images/watch/scene/WS1/WS1场景图2.jpg',
      },
      {
        src: '/images/watch/scene/WS1/WS1场景图3.jpg',
      },
      {
        src: '/images/watch/scene/WS1/WS1场景图4.jpg',
      }
    ],
    features: [
        "旋转表冠设计加震感反馈为操作带来更丰富的体验，卓越防水等级，无惧户外",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，蓝牙通话功能，AOD表盘功能，覆盖灭屏功能，手势唤醒功能，铃声自选功能，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能，天气、音乐控制、日历、计算器、小游戏等应用",
        "续航时间超过5天"
      ],
    specifications: {
        '产品尺寸': '46*40*15mm',
        '产品净重' : '37g',
        '中框材质': '塑料喷金属漆',
        '按钮材质': '铝合金',
        '屏幕类型': 'TFT-LCD',
        '屏幕尺寸': '1.85"',
        '屏幕分辨率': '320*385',
        '玻璃材质': 'Panda',
        '内存': '128MB',
        '蓝牙版本': '5.3',
        '电池容量': '400mAh',
        '充电接口': '磁吸充电',
        '防水等级': '5ATM',
        '表带材质': '硅胶'
        }
  },
  {
    id: 'watch-6',
    numericId: 706,
    name: 'BB1 运动智能手环',
    description: '提升办公效率，创造舒适办公环境',
    price: '2,999₽',
    image: '/images/watch/scene/BB1/BB1主图.jpg',
    cardImage: '/images/watch/BB1.png'
    ,
    gallery: [
      {
        src: '/images/watch/scene/BB1/BB1场景图6.jpg',
      },
      {
        src: '/images/watch/scene/BB1/BB1场景图1.jpg',
      },
      {
        src: '/images/watch/scene/BB1/BB1场景图5.jpg',
      },
      {
        src: '/images/watch/scene/BB1/BB1场景图2.jpg',
      }
    ],
    features: [
        "旋转表冠设计加震感反馈为操作带来更丰富的体验，卓越防水等级，无惧户外",
        "智能健康监测模型，全天侯连续心率监测（支持HRV监测），压力监测，血氧监测，睡眠监测，呼吸率监测，PPG血压监测，经期跟踪",
        "多种功能支持，100+主题表盘随意切换，100+运动模式数据记录，多种运动模式自动识别，来电提醒，消息提醒，走动提醒等多场景提醒功能",
        "续航时间超过5天"
      ],
    specifications: {
        '产品尺寸': '44*28.5*10.5mm',
        '产品净重' : '31.9g',
        '中框材质': '塑料',
        '屏幕类型': 'TFT-LCD',
        '屏幕尺寸': '1.57"',
        '屏幕分辨率': '200*320',
        '玻璃材质': 'Panda',
        '内存': '64MB',
        '蓝牙版本': '5.2',
        '电池容量': '170mAh',
        '充电接口': '磁吸充电',
        '防水等级': '3ATM',
        '表带材质': '硅胶'
        }
  }
]; 